"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _STEPS_TO_STATE;

var STEPS = {
  TYPE: 'type',
  CALLOUT: 'callout',
  FORM: 'form',
  THANKS: 'thanks',
  KICKBACK: 'follow-up',
  TARGETING: 'targeting',
  OPTIONS: 'options',
  PUBLISH: 'preview'
};
var PREVIEW_DYNO_STATES = (0, _keyMirror.default)({
  PREVIEW: null,
  FORM: null,
  THANKS: null,
  CLOSED: null
});
var _default = {
  STEPS: STEPS,
  PREVIEW_DYNO_STATES: PREVIEW_DYNO_STATES,
  PREVIEW_TYPES: {
    DESKTOP: 'desktop',
    TABLET: 'tablet',
    MOBILE: 'mobile'
  },
  // (step in editor) -> (state the preview dyno needs to be in)
  STEPS_TO_STATE: (_STEPS_TO_STATE = {}, (0, _defineProperty2.default)(_STEPS_TO_STATE, STEPS.TYPE, PREVIEW_DYNO_STATES.PREVIEW), (0, _defineProperty2.default)(_STEPS_TO_STATE, STEPS.CALLOUT, PREVIEW_DYNO_STATES.PREVIEW), (0, _defineProperty2.default)(_STEPS_TO_STATE, STEPS.FORM, PREVIEW_DYNO_STATES.FORM), (0, _defineProperty2.default)(_STEPS_TO_STATE, STEPS.THANKS, PREVIEW_DYNO_STATES.THANKS), (0, _defineProperty2.default)(_STEPS_TO_STATE, STEPS.KICKBACK, PREVIEW_DYNO_STATES.KICKBACK), _STEPS_TO_STATE),
  FIELDS_TO_STEP: {
    heading: STEPS.CALLOUT,
    cta: STEPS.CALLOUT,
    color: STEPS.CALLOUT,
    image: STEPS.CALLOUT,
    description: STEPS.FORM,
    formFields: STEPS.FORM,
    completedMessageHtml: STEPS.THANKS,
    redirectUrl: STEPS.THANKS,
    senderDetails: STEPS.KICKBACK,
    emailSenderUserId: STEPS.KICKBACK,
    emailSubjectLine: STEPS.KICKBACK,
    emailMessageHtml: STEPS.KICKBACK,
    companyName: STEPS.KICKBACK,
    companyStreetAddress_1: STEPS.KICKBACK,
    companyStreetAddress_2: STEPS.KICKBACK,
    companyCity: STEPS.KICKBACK,
    companyState: STEPS.KICKBACK,
    companyZip: STEPS.KICKBACK,
    companyCountry: STEPS.KICKBACK,
    companyPhone: STEPS.KICKBACK,
    name: STEPS.OPTIONS,
    triggers: STEPS.OPTIONS,
    kickback: STEPS.KICKBACK
  },
  FIELDS_TO_NAME: {
    heading: 'Callout text',
    cta: 'Button text',
    color: 'Theme color',
    name: 'Pop-up form name'
  }
};
exports.default = _default;
module.exports = exports.default;